import { render } from "./payment-success.vue?vue&type=template&id=3276fe64&scoped=true"
import script from "./payment-success.vue?vue&type=script&lang=js"
export * from "./payment-success.vue?vue&type=script&lang=js"

import "./payment-success.vue?vue&type=style&index=0&id=3276fe64&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3276fe64"]])

export default __exports__